import { GET_TALOAD_REQUEST, GET_TALOAD_SUCCESS, GET_TALOAD_FAILUER } from "./types"

export const gettaloadrequest=()=>{
    return{
        type: GET_TALOAD_REQUEST
    }
}

export const gettaloadsuccess=(cred)=>{
    return{
        type: GET_TALOAD_SUCCESS,
        payload: cred

    }
}

export const gettaloadfailure=(error)=>{
    return{
        type: GET_TALOAD_FAILUER,
        payload: error

    }
}